exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert.alert-info[data-v-386e9c39]{background:#fff;color:#2d3e52;margin-left:15px;margin-right:15px;font-size:14px;font-weight:400}.alert.alert-warning[data-v-386e9c39]{background:red;color:#fff;margin-left:15px;margin-right:15px;font-size:14px;font-weight:400}.alert .close[data-v-386e9c39],.info-box .close[data-v-386e9c39]{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-386e9c39","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/booking/Home.vue
// module id = 371
// module chunks = 0